import { api } from '@/core/helpers/axiosHelper';
const controller = new AbortController();

export class UserService {
   async get(filter_team_id?: number, search?: string) {
      return await api
         .get('/user', {
            params: {
               include: 'tenant',
               'filter[team_id]': filter_team_id,
               'filter[search]': search,
            },
         })
         .then((response) => {
            return response.data;
         });
   }
   async getInfo() {
      return await api
         .get('/user/info', { 
            params: { 
               include: 'tenant,teams,language,modules,tenant.color_theme', 
               append: 'scopes' 
            } 
         })
         .then((response) => response.data);
   }
   async patch(user_id: number, body: Array<{ path: string; value: any; op: string }>) {
      return await api.patch('/user/' + user_id, body);
   }
   async patchLanguage(user_id: number, language_id: number) {
      const BODY = [
         {
            op: 'replace',
            path: 'language_id',
            value: language_id,
         },
      ];
      const USER_LANGUAGE = await api
         .patch('/user/' + user_id, BODY, { params: { include: 'language' } })
         .then((response) => response?.data?.language);
      return USER_LANGUAGE;
   }
}
